import React, { useMemo } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import EinwaageDashboard from '../components/dashboard/EinwaageDashboard';

function decodeJwt(token) {
  try { return JSON.parse(atob(token.split('.')[1])); } catch { return null; }
}

export default function EinwaageStaffPage() {
  const navigate = useNavigate();
  const token    = localStorage.getItem('token');
  const payload  = useMemo(() => decodeJwt(token), [token]);

  if (!token || !payload || payload.role !== 'weighing') {
    return <Navigate to="/einwaage-login" replace />;
  }

  const turnier = { turnier_id: payload.turnier_id, name: payload.turnier_name || '' };

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/einwaage-login');
  };

  return (
    <div style={S.page}>
      <div style={S.header}>
        <div style={S.headerLeft}>
          <span style={S.headerIcon}>⚖</span>
          <span style={S.headerTitle}>Einwaage</span>
          {turnier.name && <span style={S.headerTurnier}>{turnier.name}</span>}
        </div>
        <div style={S.headerRight}>
          <span style={S.headerUser}>{payload.name}</span>
          <button style={S.logoutBtn} onClick={handleLogout}>Abmelden</button>
        </div>
      </div>
      <div style={S.content}>
        <EinwaageDashboard selectedTurnier={turnier} staffMode />
      </div>
    </div>
  );
}

const S = {
  page: {
    minHeight: '100vh',
    background: 'var(--bg-primary, #0d0a07)',
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
  },
  header: {
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    padding: '0.75rem 1.5rem',
    background: 'rgba(26,21,16,0.95)',
    borderBottom: '1px solid rgba(212,175,55,0.15)',
    backdropFilter: 'blur(8px)',
    position: 'sticky', top: 0, zIndex: 100,
  },
  headerLeft: { display: 'flex', alignItems: 'center', gap: '0.6rem' },
  headerIcon: { fontSize: '1.3rem' },
  headerTitle: { fontSize: '1.1rem', fontWeight: 700, color: '#e8dcc8' },
  headerTurnier: {
    fontSize: '0.8rem', color: '#8a7a5a',
    background: 'rgba(212,175,55,0.08)',
    border: '1px solid rgba(212,175,55,0.2)',
    borderRadius: 4, padding: '0.15rem 0.5rem',
  },
  headerRight: { display: 'flex', alignItems: 'center', gap: '0.75rem' },
  headerUser: { fontSize: '0.85rem', color: 'rgba(255,255,255,0.5)' },
  logoutBtn: {
    background: 'transparent',
    border: '1px solid rgba(255,255,255,0.15)',
    color: 'rgba(255,255,255,0.5)',
    borderRadius: 6, padding: '0.3rem 0.8rem',
    fontSize: '0.8rem', cursor: 'pointer',
  },
  content: { padding: '0' },
};
